// Tiny CSV builder + download trigger (client-side, no backend round-trip).
// Values are quoted and quote-escaped; a UTF-8 BOM keeps Excel happy.

export function downloadCsv(filename, headers, rows) {
  const esc = (v) => {
    const s = (v === null || v === undefined) ? '' : String(v);
    return `"${s.replace(/"/g, '""')}"`;
  };
  const lines = [headers.map(esc).join(',')];
  rows.forEach(r => lines.push(r.map(esc).join(',')));
  const blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
